<template>
  <div></div>
</template>

<script>
import { confetti } from '@tsparticles/confetti'

export default {
  props: {
    effect: {
      type: String,
      required: true
    }
  },
  created() {
    this.play()
  },
  methods: {
    play() {
      // https://confetti.js.org/more.html
      if (this.effect === 'confetti') {
        this.playConfetti()
      }
      if (this.effect === 'fireworks') {
        this.playFireworks()
      }
      if (this.effect === 'stars') {
        this.playStars()
      }
      if (this.effect === 'hearts') {
        this.playHearts()
      }
      if (this.effect === 'snow') {
        this.playSnow()
      }
    },
    playConfetti() {
      const count = 200
      const defaults = {
        origin: { y: 0.7 }
      }

      function fire(particleRatio, opts) {
        confetti(
          Object.assign({}, defaults, opts, {
            particleCount: Math.floor(count * particleRatio)
          })
        )
      }

      fire(0.25, {
        spread: 26,
        startVelocity: 55
      })

      fire(0.2, {
        spread: 60
      })

      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
      })

      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
      })

      fire(0.1, {
        spread: 120,
        startVelocity: 45
      })
    },
    playFireworks() {
      const duration = 2 * 1000,
        animationEnd = Date.now() + duration,
        defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 }

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min
      }

      const interval = setInterval(function () {
        const timeLeft = animationEnd - Date.now()

        if (timeLeft <= 0) {
          return clearInterval(interval)
        }

        const particleCount = 50 * (timeLeft / duration)

        confetti(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
          })
        )
        confetti(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
          })
        )
      }, 250)
    },
    playStars() {
      const defaults = {
        spread: 360,
        ticks: 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        shapes: ['star'],
        colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8']
      }

      function shoot() {
        confetti({
          ...defaults,
          particleCount: 40,
          scalar: 1.2,
          shapes: ['star']
        })

        confetti({
          ...defaults,
          particleCount: 10,
          scalar: 0.75,
          shapes: ['circle']
        })
      }

      setTimeout(shoot, 0)
      setTimeout(shoot, 100)
      setTimeout(shoot, 200)
    },
    playHearts() {
      const defaults = {
        spread: 360,
        ticks: 100,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        shapes: ['heart'],
        colors: ['#FFC0CB', '#FF69B4', '#FF1493', '#C71585']
      }

      confetti({
        ...defaults,
        particleCount: 50,
        scalar: 2
      })

      confetti({
        ...defaults,
        particleCount: 25,
        scalar: 3
      })

      confetti({
        ...defaults,
        particleCount: 10,
        scalar: 4
      })
    },
    playSnow() {
      const duration = 2 * 1000,
        animationEnd = Date.now() + duration

      let skew = 1

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min
      }

      ;(function frame() {
        const timeLeft = animationEnd - Date.now(),
          ticks = Math.max(200, 500 * (timeLeft / duration))

        skew = Math.max(0.8, skew - 0.001)

        confetti({
          particleCount: 1,
          startVelocity: 0,
          ticks: ticks,
          origin: {
            x: Math.random(),
            y: Math.random() * skew - 0.2
          },
          colors: ['#ffffff'],
          shapes: ['circle'],
          gravity: randomInRange(0.4, 0.6),
          scalar: randomInRange(0.4, 1),
          drift: randomInRange(-0.4, 0.4)
        })

        if (timeLeft > 0) {
          requestAnimationFrame(frame)
        }
      })()
    }
  }
}
</script>

<style>
#confetti canvas {
  z-index: 999999;
  pointer-events: none;
}
</style>
